import { format } from 'date-fns';

export default function simpleFormatDate(date: Date): string {
  return format(date, "M/dd/yyyy 'at' h:mma");
}
